import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Chip from '@material-ui/core/Chip';
import ErrorIcon from '@material-ui/icons/Error';

import { paymentPropType } from '../../../types/subscription';

import InlineSection from '../../InlineSection';
import PaymentIcon from '../../PaymentIcon';
import { orResolver } from '../../../util/helpers';
import { isPaymentTypeCreditCard } from '../utils/helpers';
import { getPaymentIconSrc } from '../../../util/getPaymentIconSrc';

const validPaymentData = ({ payment, theme }) => ({
    icon: {
        component: (
            <PaymentIcon
                iconSrc={ getPaymentIconSrc(payment.paymentIconType) }
                alt={ payment.paymentIconType }
                theme={ theme }
            />
        ),
    },
    mainContent: payment.paymentMethod.text,
    subContent: payment.paymentDetail,
});

const expiredCreditCardData = ({ payment, theme, formatMessage }) => ({
    icon: {
        component: <ErrorIcon color="error" className={ classNames(theme.errorIcon, theme.paymentIcon) } />,
    },
    mainContent: (
        <div className={ theme.extendedMainContent }>
            <span>
                {payment.paymentMethod.text}
                {' '}
                (
                {payment.paymentDetail}
                )
            </span>
            <span className={ theme.label }>
                <FormattedMessage
                    id="payment.cardExpired.message"
                    values={{
                        expiryDate: moment(payment.expiryDate)
                            .subtract(1, 'day')
                            .format('MM/YY'),
                    }}
                />
            </span>
        </div>
    ),
    subContent: <Chip
        label={ formatMessage('payment.cardExpired.chip') }
        color="secondary"
        className={ theme.chip }
    />,
});

const SubscriptionPaymentDetail = ({ payment, theme, formatMessage }) => {
    const isCreditCard = isPaymentTypeCreditCard({ payment });
    const isPaymentExpired = payment.expiryDate && moment(payment.expiryDate).diff(moment()) < 0;
    const renderData = orResolver({ payment, theme, formatMessage })([
        [isCreditCard && isPaymentExpired, expiredCreditCardData],
        [true, validPaymentData],
    ]);

    return (
        <InlineSection
            { ...renderData }
            theme={ theme }
            classNames={{
                [theme.paymentDetail]: true,
                [theme.creditCard]: isCreditCard && !isPaymentExpired,
            }}
        />
    );
};

SubscriptionPaymentDetail.propTypes = {
    payment: paymentPropType.isRequired,
    theme: PropTypes.shape({}),
    formatMessage: PropTypes.func.isRequired,
};

export default SubscriptionPaymentDetail;
